export const UNSAVED_CHANGES_PROMPT =
  "You have unsaved changes. Are you sure you want to leave?";
export const UPDATE = "Update";
export const SUBMIT = "Submit";
export const MASCOT_INPUT_LABEL="Mascot: "
export const TAGLINE_INPUT_LABEL = "Tagline: ";
export const TAGLINE_INPUT_PLACEHOLDER = "Go Eagles!";
export const MASCOT_INPUT_PLACEHOLDER = "Mascot";
export const SLUG_INPUT_LABEL = "Slug: ";
export const SLUG_INPUT_PLACEHOLDER = "grcc";
export const LOGO_1_INPUT_LABEL = "Logo #1: ";
export const LOGO_2_INPUT_LABEL = "Logo #2: ";
export const PRIMARY_COLOR_INPUT_LABEL = "Primary Color: ";
export const SECONDARY_COLOR_INPUT_LABEL = "Secondary Color: ";

export const DIRECTORS_HEADING = "School Admins";
export const DIRECTOR_ADD_EMAIL = "Add";
export const DIRECTOR_DELETE_TOOLTIP = "Delete";
export const DIRECTOR_EDIT_TOOLTIP = "Edit permissions";

export const TEMPLATES_HEADING = "Templates";
export const TEMPLATES_BODY =
  "Only 1 template can be assigned to a school. Remove the current template before assigning another one.";
export const TEMPLATE_LINK_TOOLTIP = "Link";
export const TEMPLATE_DELETE_TOOLTIP = "Delete";

export const MODAL_TITLE = "Edit permissions";
export const GET_MODAL_SUBTITLE = (email: string) => `School Admin: ${email}`;
export const MODAL_CHECK_ALL = "check all";
export const MODAL_UNCHECK_ALL = "uncheck all";
export const MODAL_ALLOWED_COACHES = "Viewable coaches";
export const MODAL_CLOSE = "Close";



// WEBPACK FOOTER //
// ./src/pages/admin/SchoolEditorPage/constants.ts